// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2023project/q4/2023manufactureThird/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const getVoteList = (order: number, page: number, search: string) => {
  return http.get(`${urlPrefix}vote-list`, {
    params: {
      order,
      page,
      search,
    },
  });
};

const getDetail = (id: any) => {
  return http.get(`${urlPrefix}detail`, {
    params: {
      id,
    },
  });
};

const getNews = (page: any, category: any, classId: any) => {
  return http.get(
    `/v1/news/topicList?page=${page}&classId=${classId}&category=${category}`,
  );
};

const addView = () => {
  return http.get(`${urlPrefix}view`);
};

const mainMessage = () => {
  return http.get(`${urlPrefix}main-message`);
};

const getRules = (id: number) => {
  const data: { [key: number]: string } = {
    1: `<p>为深入贯彻习近平总书记“弘扬企业家精神”重要讲话精神，全面落实重庆市推动制造业高质量发展大会、新型工业化发展暨开发区改革工作推进会精神，按照《重庆市制造业领军企业培育行动实施方案》要求，对推动重庆市制造业（含软件服务业）高质量发展做出卓越贡献、取得突出成绩的优秀企业家进行表彰，“重庆市制造业十大影响力年度人物评选活动”将继续举办。活动旨在挖掘一批在2023年度对推动重庆市制造业高质量发展做出突出贡献的企业优秀经营管理人才进行激励、表彰，树立标杆、塑造典型，全面客观展现我市制造业高质量发展成效，在全社会形成尊重企业家、学习企业家的良好风尚，为推动重庆市制造业高质量发展做出更大贡献。</p>`,
    2: `<h4>一、指导单位</h4>
<p>中共重庆市委宣传部、重庆市经济和信息化委员会</p>
<h4>二、主办单位</h4>
<p>重庆日报报业集团</p>
<h4>三、承办单位</h4>
<p>上游新闻</p>
<h4>四、媒体单位</h4>
<p>重庆日报、上游新闻、重庆电视台、重庆晨报、重庆晚报、重庆商报、华龙网等</p>`,
    3: `<h4>第三届重庆市制造业十大影响力年度人物</h4>`,
    4: `<p>参评对象为个人，主要面向制造业领域（含软件信息服务业），重点聚焦重庆市重点培育领军（链主）企业、“双百企业”、国家专精特新“小巨人”企业、单项冠军企业、专精特新中小企业等主要经营管理负责人、高级经营管理人才、高级技术人才以及具有突出贡献的创新人才等，其在推动重庆市制造业高质量发展进程中，带领企业在重要领域和关键技术攻坚突破、落地见效，并在提升产业生成能力、产业迭代能力和产业把控能力，以及实现科技创新产业创新、培育优质企业、促进重庆制造提质增效、加快全面数字化转型、促进绿色低碳发展行动、加快产业布局调整优化、深化开放合作、提升要素保障能力等方面做出突出贡献。</p>
<p>一、坚持正确政治方向，热爱祖国，自觉践行社会主义核心价值观。</p>
<p>二、遵守宪法和法律。</p>
<p>三、具有良好的职业道德，诚实守信，爱岗敬业，学风严谨，为人正派，在制造业（行业）具有良好声誉，本人及所在单位近三年没有严重违规违法行为。</p>
<p>四、2023全年度在同一单位担任董事长、总裁或总经理等主要领导职务。</p>
<p>五、须在2023年度对推动重庆市制造业高质量发展做出重大贡献，形成社会影响力。至少符合下列条件之一：</p>
<p><span>（一）引领行业发展。</span>参评人所经营管理的企业发挥较强的行业推动及引领作用，在技术成果、创新产品、平台建设、行业改革等方面有效助推制造业转型升级发展，在解决重要问题、降本增效、节能降耗方面具有较好成效，在全市、全国或者国际上有重大影响，对重庆市制造业优化升级和提振发展起到积极支撑和推动作用。</p>
<p><span>（二）经济表现强劲。</span>参评人所经营管理的企业在行业细分领域拥有较好的市场地位，在上规模、增效益、带动上下游企业发展等方面拥有较为强劲的经济表现。</p>
<p><span>（三）培养优秀人才。</span>参评人重视引进和培养人才，在创新人才培养体制机制、多渠道帮助青年人才成长、改革推进富有成效薪酬激励机制等方面有创新性措施，极大地调动人才队伍干事创业激情。</p>
<p><span>（四）公众影响深远。</span>参评人具有深远的公众影响力、知名度、诚信度，能够通过个人领导力带动制造业行业、企业、团队等方面的发展，积极关注并支持社会公益事业建设。</p>`,
    5: `<p><span>一、宣传发动。</span>中共重庆市委宣传部、重庆市经济和信息化委员会指导推进评选工作，上游新闻以报刊、网络等形式广泛宣传评选活动。</p>
    <p><span>二、组织申报（截止1月31日）。</span>动员广大参评对象积极参与，接收、汇总、整理参评对象申报材料，对申报材料进行合规性初审。</p>
    <p><span>三、政审考察。</span>书面征求市级相关部门（如市市场监督管理局、市公安局、市税务局、市检察院等）意见，对报名参评对象进行政治资格审查，确定入围核查环节人选。</p>
    <p><span>四、入围核查。</span>根据实际情况，采取实地走访、线上沟通、电话访谈等形式对参评对象申报材料真实性、合规性等进行核查，确定综合评选环节人选。</p>
    <p><span>五、综合评审。</span>评审委员会对入围的参评人进行综合评价，产生获奖建议名单，并报组委会审议。</p>
    <p><span>六、对外公示。</span>组委会审议通过获奖建议名单，由主流媒体向社会进行公示。</p>
    <p><span>七、审定名单。</span>经公示无异议后，组委会最终审定获奖名单。</p>
    <p><span>八、表彰宣传。</span>举行颁奖仪式，向获奖者颁发证书和奖杯；各类媒体以电视、广播、网络、报刊等形式对年度人物进行集中宣传，营造浓厚氛围。</p>
    <p>注：具体执行流程及时间以组委会通知为准。</p>`,
    6: `<h4>报名表下载：</h4>
    <p><a download="第三届重庆市制造业十大影响力年度人物报名表" href="https://image2.cqcb.com/webupload/third_application_form.docx">
    第三届重庆市制造业十大影响力年度人物报名表
    </a></p>
    <h4>报名咨询电话：</h4>
    <p>郑老师 18602382270（微信同号）</p>
    <p>李老师 15215052940（微信同号）</p>
    <h4>报名材料上传邮箱：</h4>
    <p>994226176@qq.com </p>`,
  };
  return data[id];
};
export { getBaseInfo, getVoteList, getDetail, getRules, addView, mainMessage, getNews };
